import { DEFAULT_SAMPLING_RATES, ENVIRONMENT_SAMPLING_RATES } from './constants'
import type { SamplingRates } from './types'

/**
 * Normalizes environment string to a standard environment key (test, staging, prod)
 * @param env - Environment string (case-insensitive)
 * @returns Normalized environment key
 */
const normalizeEnvKey = (env: string): 'test' | 'staging' | 'prod' => {
  const normalized = env.toLowerCase().trim()

  if (normalized === 'prod' || normalized === 'production') {
    return 'prod'
  }

  if (normalized === 'staging') {
    return 'staging'
  }

  return 'test'
}

/**
 * Retrieves sampling rates from localStorage with environment-aware defaults.
 * Override via localStorage keys: dd_sample_rate_{env}, dd_replay_rate_{env}, dd_logs_rate_{env}, dd_trace_rate_{env}
 * @param env - Environment identifier (test, staging, prod)
 * @returns Sampling rates for session, replay, logs, and trace
 */
export const getSamplingRates = (env: string): SamplingRates => {
  if (typeof window === 'undefined') {
    return DEFAULT_SAMPLING_RATES
  }

  const storage = window.localStorage
  const envKey = normalizeEnvKey(env)
  const envDefaults = ENVIRONMENT_SAMPLING_RATES[envKey]

  return {
    session: Number(storage.getItem(`dd_sample_rate_${envKey}`) || envDefaults.session),
    replay: Number(storage.getItem(`dd_replay_rate_${envKey}`) || envDefaults.replay),
    logs: Number(storage.getItem(`dd_logs_rate_${envKey}`) || envDefaults.logs),
    trace: Number(storage.getItem(`dd_trace_rate_${envKey}`) || envDefaults.trace)
  }
}
